import React from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBrandsProps, IconRender } from '../types.ts';

const X = React.forwardRef<SVGSVGElement | null, IconBrandsProps>(function X({ colored, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = React.useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          d='M9.06615 6.7798H7.44011L14.9248 17.2557H16.5508L9.06615 6.7798ZM6 6H9.57328L12.6714 10.4119L16.5503 6H17.6089L13.1415 11.0813L18 18H14.4267L11.1549 13.3408L7.05866 18H6L10.6849 12.6714L6 6Z'
          fill={colored ? 'transparent' : color}
        />
        {/* colored */}
        <circle cx='12' cy='12' r='10' fill={colored ? '#2E2F33' : 'transparent'} />
        <path
          d='M9.06615 6.7798H7.44011L14.9248 17.2557H16.5508L9.06615 6.7798ZM6 6H9.57328L12.6714 10.4119L16.5503 6H17.6089L13.1415 11.0813L18 18H14.4267L11.1549 13.3408L7.05866 18H6L10.6849 12.6714L6 6Z'
          fill={colored ? 'white' : 'transparent'}
        />
      </>
    ),
    [colored],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'x-icon-svg'} iconRender={iconRender} {...props} />;
});

export default X;
